import { BookService } from '@DavisDigital/davisdigitalfrontend.module';
declare var $; // jQuery

class BookListingController {

	public isRendering: boolean = true;
	
	public booksBySchool: any = {};
	
	// Stores active book & resource type after triggering the resources modal.
	public activeBook: any = null;
	public activeResourceType: any = null;
	
	// Stores active video when a video resource is played.
	public activeVideo: any = '';
	
	public canSelfAssign: boolean = false; 
	public hasBooks: boolean = true;
	public hasPendingLicenseAssignment: boolean = false;
	public selfAssignFailed: boolean = false; 
	public bookImageCollection: string = '';
	
	public countdown = 30; 

	// @ngInject
	constructor(
		private $sce,
		private $interval, 
		private $timeout,
		private bookService: BookService,
		private licenseService,
		private ModalService,
		private $window,
		private $q: ng.IQService,
		private $location
	) {}

	public $onInit = () => {
		
		this.initBooks();
		
		
		$('#bookListingModal').on('hidden.bs.modal', function () {
			// Refresh iframe src to stop it
			$('#bookListingModal iframe').attr( 'src', $('#bookListingModal iframe').attr('src') );
		});
	}
	
	public isSampleBook = (bookCode) => this.bookService.isSampleBook(bookCode);
	
	public initBooks = () =>{

		this.bookService.getBookListingData().then( (data) => {
			this.hasBooks = data.length !== 0;
			this.booksBySchool = data;
			this.isRendering = false;
		}).finally(()=>{
			
			if(!this.hasBooks){
				
				this.$interval(()=>{
					if(this.countdown > 0){
						this.countdown--;
					}
				}, 1000);
				
				this.licenseService.hasPendingLicenseAssignment().then ( data =>{
					
					this.hasPendingLicenseAssignment = data.data.hasPendingLicenseAssignment; 
				
					if(this.hasPendingLicenseAssignment){
						this.watchPendingLicenseAssignment();
					} else {
						this.licenseService.canSelfAssign().then( (data) =>{
							this.canSelfAssign = data; 	
						});
					}
				});
			} else {
				this.hasPendingLicenseAssignment = false; 
			}
			
		});
	}
	
	public watchPendingLicenseAssignment = () =>{
		this.$timeout(
			()=>{
				this.licenseService.hasPendingLicenseAssignment().then ( data =>{
					this.hasPendingLicenseAssignment = data.data.hasPendingLicenseAssignment;
					if(this.hasPendingLicenseAssignment){
						this.countdown = 30;
						this.watchPendingLicenseAssignment();
					} else {
						this.loadBooksAfterSelfAssign();
					}
				});
			},
			30000
		);
	}
	
	public loadBooksAfterSelfAssign = (tryCount=1, timeout=3000) =>{
		
		if(tryCount > 5){
			this.isRendering = false;
			//something went wrong with the self assign could be used to notify user 
			this.selfAssignFailed = true;
			return;
		}
		
		this.isRendering = true;
		
		this.$timeout(
			()=>{
				this.bookService.getBookListingData().then( (data) => {
					
					this.hasBooks = data.length !== 0;
					this.booksBySchool = data;
					
					if(this.hasBooks){
						this.isRendering = false;
					} else {
						//licenses may be off the queue but still being processed, we need to give workflow some time to work
						//timeout will grow increasingly longer the more times it fails
						this.loadBooksAfterSelfAssign( ++tryCount, timeout * 2 );
					}
				})
			}, 
			timeout
		);
	}
	
	public launchSupportTicketModal = () =>{
		this.ModalService.showModal({
			component: 'supportTicketModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
			},
			preClose: (modal) => {
				modal.element.modal('hide');
			}
		})
		.then((modal) => {
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	}
	
	public openResourcesModal = ( book, resourceType ) => {
		this.ModalService.showModal({
			component: 'bookResourcesModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				book: book, 
				resourceType: resourceType
			},
			preClose: (modal) => {
				modal.element.modal('hide');
			}
		})
		.then((modal) => {
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	}
	
	public getSingleBookURL = ( bookID: string ): string => {
		return `/book/?bookID=${bookID}`;
	}
	
	public getBookCollectionURL = ( book ) => {
		this.bookImageCollection = book.bookImageCollection_imageSetID;
		return window.open(`/images?tab=bookcollections&currentPage=1&imagesetid=${this.bookImageCollection}`, '_blank');	
	}
}

export { BookListingController };